import sendHttpError from '@/libs/logger/requests/send-http-error';

import {
  type BudgetValues,
  type CurrencySymbols,
} from '../types/currency-types';

export default async function getBudgetFilterValues(currency: CurrencySymbols['name']): Promise<BudgetValues> {
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/budgetsettings`;
  const headers: HeadersInit = { Currency: currency };
  const result = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}/v1/budgetsettings`,
    {
      cache: 'no-store',
      headers,
    },
  );

  // TODO: rewrite to flow without break APP
  if (!result.ok) {
    sendHttpError({
      baseName: 'Get budget settings for min/max values',
      functionName: 'getBudgetFilterValues',
      method: 'GET',
      requestHeaders: headers,
      statusCode: result.status,
      url,
    });
    throw new Error('Failed to fetch data');
  }

  return result.json() as Promise<BudgetValues>;
}
